import * as React from 'react'
import PropTypes from 'prop-types'

const ATMIcon = ({ size = 48, color = '#101820' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6061_40250)" fill={color}>
        <path d="M44.57 0H3.43c-.451 0-.897.09-1.313.264-.417.175-.795.431-1.113.754A3.48 3.48 0 00.26 2.147C.088 2.569 0 3.02 0 3.477v8.403c0 .923.361 1.807 1.004 2.46a3.405 3.405 0 002.425 1.018h3.099l.518-6.998H3V6.997h42.002V8.36h-4.06l.518 6.998h3.112c.91 0 1.782-.366 2.425-1.019A3.503 3.503 0 0048 11.88V3.478c0-.457-.088-.91-.26-1.331a3.48 3.48 0 00-.744-1.129 3.424 3.424 0 00-1.113-.754A3.385 3.385 0 0044.571 0z" />
        <path d="M38.346 8.36l2.58 34.84a3.49 3.49 0 01-1.009 2.43 3.393 3.393 0 01-2.404 1.007H19.849l.563-38.278H14.7l-1.452 38.278h-2.774a3.393 3.393 0 01-2.404-1.008 3.49 3.49 0 01-1.008-2.431l2.58-34.839H8.298L5.72 43.124v.05a4.864 4.864 0 001.394 3.41A4.729 4.729 0 0010.476 48h27.037a4.73 4.73 0 003.363-1.415 4.867 4.867 0 001.395-3.41v-.026L39.694 8.36h-1.348z" />
      </g>
      <defs>
        <clipPath id="clip0_6061_40250">
          <path fill="red" d="M0 0H48V48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

ATMIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(ATMIcon)
